const amountOfEagerLoadedImages = 10

export const isListItemLazy = (index: number): boolean => index >= amountOfEagerLoadedImages
